import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';

import { SmallTileList } from './SmallTileList';

const StyledTileListContainer = styled.div`
  height: 233px;
  margin-bottom: 16px;
`;

const SmallDroppableColumn = props => (
  <Droppable droppableId={props.columnId} direction="horizontal">
    {provided => (
      <StyledTileListContainer
        ref={provided.innerRef}
        {...provided.droppableProps}
      >
        <SmallTileList
          columnNumber={props.columnNumber}
          tiles={props.tiles}
          columnId={props.columnId}
        />
        {provided.placeholder}
      </StyledTileListContainer>
    )}
  </Droppable>
);

SmallDroppableColumn.propTypes = {
  columnId: PropTypes.string.isRequired,
  tiles: PropTypes.array,
  columnNumber: PropTypes.number,
};

export { SmallDroppableColumn };
